export function getUrlParam(name: string): string {
    const url = new URL(window.location.href);
    return url.searchParams.get(name) ?? "";
}

export function getUrlParamInt(name: string, alternate?: number): number {
    if (typeof alternate !== "number") {
        alternate = 0;
    }
    const num = parseInt(getUrlParam(name))
    return isNaN(num) ? alternate : num;
}

export function setUrlParam(name: string, value: string): void {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    if (value === "") {
        params.delete(name);
    } else {
        params.set(name, value);
    }

    url.search = params.toString();
    history.replaceState(null, "", url.toString());
}
